(() => {
  'use strict';
  const dialog = document.getElementById('d3-floating-cart');
  const configElement = document.getElementById('d3-floating-cart-config');
  if (!dialog || !configElement || typeof dialog.showModal !== 'function') return;
  const config = JSON.parse(configElement.textContent);
  const t = config.strings;
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  const find = name => dialog.querySelector('[data-fc-' + name + ']');
  let cart = null;
  let busy = false;
  let valid = false;
  let opener = null;
  let cartChanged = false;
  let quantityTimer;
  const pendingQuantities = new Map();
  const beerIds = new Set(config.variants.map(v => Number(v.id)));
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
    style: 'currency', currency: cart?.currency || 'EUR'
  }).format(value / 100);
  const discountPercent = (original, total) => original > 0 && total < original ? Math.max(0, Math.floor((original - total) * 100 / original)) : 0;
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const button = (label, className, action) => {
    const element = node('button', className, label);
    element.type = 'button';
    element.addEventListener('click', action);
    return element;
  };
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('button,input,select').forEach(el => {
      if (!el.hasAttribute('data-fc-close')) el.disabled = value;
    });
    find('checkout').disabled = value || !valid || !cart?.item_count;
    find('status').textContent = value ? t.loading : '';
  }
  function error(message) {
    find('error').hidden = false;
    find('error').querySelector('p').textContent = message || t.error;
  }
  function clearError() { find('error').hidden = true; }
  async function request(path, data) {
    const form = typeof FormData !== 'undefined' && data instanceof FormData;
    const response = await fetch(root + path, {
      credentials: 'same-origin', cache: 'no-store',
      method: data ? 'POST' : 'GET',
      headers: data && !form ? {'Content-Type': 'application/json', Accept: 'application/json'} : {Accept: 'application/json'},
      ...(data ? {body: form ? data : JSON.stringify(data)} : {})
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status >= 400) {
      throw new Error(typeof result.description === 'string' ? result.description :
        typeof result.message === 'string' ? result.message : t.error);
    }
    return result;
  }
  function updateHeader() {
    document.querySelectorAll('.bm-cart-link__count, .cart-count-bubble span[aria-hidden="true"]').forEach(el => el.textContent = cart.item_count);
    document.querySelectorAll('.bm-cart-link').forEach(el => {
      el.setAttribute('aria-label', t.title + ', ' + cart.item_count);
      el.setAttribute('aria-haspopup', 'dialog');
      el.setAttribute('aria-controls', dialog.id);
    });
  }
  function plainLine(item) {
    return !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
  }
  function editColor(item, row) {
    if (busy) return;
    const existing = row.querySelector('.d3fc__editor');
    if (existing) { existing.remove(); return; }
    const editor = node('div', 'd3fc__editor');
    const label = node('label', '', t.variant);
    const select = node('select');
    select.id = 'd3fc-variant-' + item.variant_id;
    label.htmlFor = select.id;
    config.variants.filter(v => v.available || Number(v.id) === item.variant_id).forEach(v => {
      const option = node('option', '', v.title);
      option.value = String(v.id);
      option.selected = Number(v.id) === item.variant_id;
      option.disabled = !v.available;
      select.append(option);
    });
    const actions = node('div', 'd3fc__editor-actions');
    actions.append(button(t.save, 'd3fc__save', async () => {
      const chosen = Number(select.value);
      if (chosen === item.variant_id) { editor.remove(); return; }
      if (!beerIds.has(chosen)) return;
      const matching = cart.items.filter(line => line.variant_id === chosen);
      if (matching.some(line => !plainLine(line))) { error(t.variant_error); return; }
      const updates = {[item.key]: 0};
      const targetQuantity = matching.reduce((sum, line) => sum + line.quantity, 0) + item.quantity;
      if (matching.length) {
        matching.forEach(line => updates[line.key] = 0);
        updates[matching[0].key] = targetQuantity;
      } else updates[String(chosen)] = targetQuantity;
      await mutate(() => request('cart/update.js', {updates}));
    }), button(t.cancel, 'd3fc__text-button', () => editor.remove()));
    editor.append(label, select, actions);
    row.append(editor);
    select.focus();
  }
  function renderItem(item) {
    const row = node('article', 'd3fc__item' + (beerIds.has(item.variant_id) ? ' d3fc__item--beer' : ''));
    row.dataset.cartKey = item.key;
    const imageLink = node('a', 'd3fc__image-link');
    imageLink.href = item.url;
    imageLink.setAttribute('aria-label', item.product_title);
    if (item.image) {
      const image = node('img');
      image.src = item.image;
      image.alt = item.variant_title || item.product_title;
      image.width = 78; image.height = 88;
      image.loading = 'lazy';
      imageLink.append(image);
    }
    const info = node('div', 'd3fc__info');
    info.append(node('h3', '', beerIds.has(item.variant_id) ? 'Bierhandschoen' : item.product_title));
    if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', 'd3fc__variant', item.variant_title));
    for (const [name, value] of Object.entries(item.properties || {})) {
      if (!name.startsWith('_') && value) info.append(node('p', 'd3fc__property', name + ': ' + value));
    }
    if (item.selling_plan_allocation) info.append(node('p', 'd3fc__property', item.selling_plan_allocation.selling_plan.name));
    const prices = node('div', 'd3fc__line-price');
    if (item.original_line_price > item.final_line_price) prices.append(node('s', '', money(item.original_line_price)));
    prices.append(node('strong', '', money(item.final_line_price)));
    prices.setAttribute('aria-label', t.line_total);
    const tools = node('div', 'd3fc__tools');
    const stepper = node('div', 'd3fc__stepper');
    const minus = button('−', '', () => change(item.key, Math.max(0, Number(input.value) - 1)));
    minus.setAttribute('aria-label', t.less + ': ' + (item.variant_title || item.product_title));
    const input = node('input');
    input.type = 'number'; input.min = '0'; input.step = '1';
    input.inputMode = 'numeric'; input.value = String(item.quantity);
    input.setAttribute('aria-label', t.quantity + ': ' + (item.variant_title || item.product_title));
    const queueQuantity = commit => {
      window.clearTimeout(quantityTimer);
      const quantity = Number(input.value);
      if (input.value === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
        if (commit) { input.value = String(item.quantity); pendingQuantities.delete(item.key); }
        else { valid = false; find('checkout').disabled = true; return; }
      } else pendingQuantities.set(item.key, quantity);
      valid = false;
      find('checkout').disabled = true;
      if (commit) void flushQuantities();
      else quantityTimer = window.setTimeout(flushQuantities, 450);
    };
    input.addEventListener('input', () => queueQuantity(false));
    input.addEventListener('change', () => queueQuantity(true));
    const plus = button('+', '', () => change(item.key, Math.max(0, Number(input.value)) + 1));
    plus.setAttribute('aria-label', t.more + ': ' + (item.variant_title || item.product_title));
    stepper.append(minus, input, plus);
    const remove = button(t.remove, 'd3fc__remove', () => change(item.key, 0));
    tools.append(stepper, remove);
    info.append(prices, tools);
    if (beerIds.has(item.variant_id) && plainLine(item)) info.append(button(t.edit, 'd3fc__edit', () => editColor(item, row)));
    row.append(imageLink, info);
    return row;
  }
  function render() {
    const body = find('body');
    body.replaceChildren();
    find('count').textContent = String(cart.item_count);
    find('footer').hidden = !cart.item_count;
    dialog.classList.toggle('d3fc--empty',!cart.item_count);
    const original = cart.items.reduce((sum, item) => sum + item.original_line_price, 0);
    const saving = Math.max(0, original - cart.total_price);
    find('discount').hidden = !saving;
    if (!cart.item_count) {
      const empty = node('section', 'd3fc__empty');
      empty.setAttribute('aria-label', t.empty);
      const hero = node('div', 'd3fc__empty-hero');
      const visual = node('div', 'd3fc__empty-visual');
      if (config.productImage) {
        const image = node('img');
        image.src = config.productImage;
        image.alt = t.shop;
        image.width = 108; image.height = 108;
        image.loading = 'lazy';
        visual.append(image);
      } else {
        const symbol = node('span', 'd3fc__empty-placeholder', 'D3');
        symbol.setAttribute('aria-hidden', 'true');
        visual.append(symbol);
      }
      const copy = node('div', 'd3fc__empty-copy');
      copy.append(node('h3', '', t.empty), node('p', '', t.empty_text));
      hero.append(visual, copy);
      const link = node('a', 'd3fc__shop', t.shop + ' →');
      link.href = config.productUrl || config.root;
      const benefits = node('p', 'd3fc__empty-benefits', '✓ ' + t.shipping + '  ·  ' + t.returns);
      empty.append(hero, link, benefits);
      body.append(empty);
    } else cart.items.forEach(item => body.append(renderItem(item)));
    const beerItems = cart.items.filter(item => beerIds.has(item.variant_id));
    const quantities = new Map();
    beerItems.forEach(item => quantities.set(item.final_price, (quantities.get(item.final_price) || 0) + item.quantity));
    find('unit').textContent = [...quantities].map(([price, quantity]) => quantity + ' ' + (quantity === 1 ? t.piece : t.pieces) + ' × ' + money(price) + ' ' + t.per_piece).join(' · ');
    find('unit').hidden = !beerItems.length;
    find('delivery').hidden = !cart.item_count || beerItems.length !== cart.items.length;
    find('original').textContent = saving ? money(original) : '';
    find('original').hidden = !saving;
    find('total').textContent = money(cart.total_price);
    find('saving').textContent = saving ? t.saving + ' ' + money(saving) + ' ' + t.on_order : '';
    find('saving').hidden = !saving;
    const beerOriginal = beerItems.reduce((sum, item) => sum + item.original_line_price, 0);
    const beerTotal = beerItems.reduce((sum, item) => sum + item.final_line_price, 0);
    const beerPercent = discountPercent(beerOriginal, beerTotal);
    const percent = beerPercent || discountPercent(original, cart.total_price);
    const mixedBeerSaving = beerPercent > 0 && beerItems.length !== cart.items.length;
    find('saving-rate').textContent = percent + (mixedBeerSaving ? '% voordeel op bierhandschoenen' : '% voordeel');
    find('saving-rate').hidden = !percent || !saving;
    updateHeader();
  }
  async function refresh() {
    const result = await request('cart.js');
    cart = result; valid = true; render();
    document.dispatchEvent(new CustomEvent('d3:cart:updated', {detail: {cart}}));
    return cart;
  }
  function show() {
    if (!dialog.open) {
      opener = document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('d3fc-open');
      find('close').focus();
    }
  }
  async function open() {
    show();
    if (busy) return;
    setBusy(true); clearError(); valid = false;
    try { await refresh(); } catch (_) { error(); }
    finally { setBusy(false); }
  }
  async function mutate(action) {
    if (busy) return false;
    const focused = document.activeElement;
    const focusLabel = focused?.getAttribute('aria-label');
    setBusy(true); clearError(); valid = false;
    try {
      await action();
      cartChanged = true;
      await refresh();
      return true;
    } catch (e) {
      try { await refresh(); } catch (_) { valid = false; }
      error(e.message);
      return false;
    } finally {
      setBusy(false);
      if (focusLabel) [...dialog.querySelectorAll('[aria-label]')].find(el => el.getAttribute('aria-label') === focusLabel)?.focus();
    }
  }
  async function flushQuantities() {
    window.clearTimeout(quantityTimer);
    if (busy) return;
    const updates = Object.fromEntries([...pendingQuantities].filter(([key, quantity]) => cart?.items.some(item => item.key === key && item.quantity !== quantity)));
    pendingQuantities.clear();
    const entries = Object.entries(updates);
    if (!entries.length) { valid = true; setBusy(false); return; }
    await mutate(() => entries.length === 1 ?
      request('cart/change.js', {id: entries[0][0], quantity: entries[0][1]}) :
      request('cart/update.js', {updates}));
  }
  async function change(key, quantity) {
    if (!cart?.items.some(item => item.key === key)) return;
    await mutate(() => request('cart/change.js', {id: key, quantity}));
  }
  async function add(data) {
    if (busy) throw new Error(t.loading);
    setBusy(true); clearError(); valid = false;
    let added = false;
    try {
      await request('cart/add.js', data);
      added = true;
      cartChanged = true;
      show();
      await refresh();
    } catch (e) {
      if (!added) throw e;
      show(); error(t.added_error);
    } finally { setBusy(false); }
  }
  dialog.querySelectorAll('[data-fc-close]').forEach(el => el.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('d3fc-open');
    if (opener?.isConnected) opener.focus();
    if (cartChanged && location.pathname.replace(/\/$/, '') === config.cartUrl.replace(/\/$/, '')) location.reload();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  find('refresh').addEventListener('click', open);
  find('checkout').closest('form').addEventListener('submit', event => {
    if (busy || !valid || !cart?.item_count) event.preventDefault();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== config.cartUrl.replace(/\/$/, '') || url.search || url.hash) return;
    event.preventDefault(); event.stopImmediatePropagation(); void open();
  }, true);
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
    const data = new FormData(form);
    if (!data.get('id') && ![...data.keys()].some(key => key.startsWith('items['))) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    const submit = event.submitter;
    const wasDisabled = submit?.disabled;
    if (submit) submit.disabled = true;
    const oldError = form.querySelector('[data-d3-add-error]');
    oldError?.remove();
    try { await add(data); }
    catch (e) {
      const message = node('p', 'd3fc__product-error', e.message);
      message.dataset.d3AddError = ''; message.setAttribute('role', 'alert'); form.append(message);
    } finally { if (submit) submit.disabled = wasDisabled; }
  }, true);
  window.D3Cart = {open, addItems: items => add({items}), refresh: open};
})();
